import { render, staticRenderFns } from "./service-form.vue?vue&type=template&id=40fdc63f&scoped=true"
import script from "./service-form.vue?vue&type=script&lang=js"
export * from "./service-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fdc63f",
  null
  
)

export default component.exports